var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "訂單編號",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "orderno"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              disabled: "false",
                              placeholder: "请输入訂單編號"
                            },
                            model: {
                              value: _vm.model.orderno,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "orderno", $$v)
                              },
                              expression: "model.orderno"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "商品ID",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "productId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              disabled: "false",
                              placeholder: "请输入商品ID"
                            },
                            model: {
                              value: _vm.model.productId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "productId", $$v)
                              },
                              expression: "model.productId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "商品名稱",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "productName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              disabled: "false",
                              placeholder: "请输入商品名稱"
                            },
                            model: {
                              value: _vm.model.productName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "productName", $$v)
                              },
                              expression: "model.productName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "員工工號",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              disabled: "false",
                              placeholder: "请输入員工工號"
                            },
                            model: {
                              value: _vm.model.empId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empId", $$v)
                              },
                              expression: "model.empId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "員工姓名",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              disabled: "false",
                              placeholder: "请输入員工姓名"
                            },
                            model: {
                              value: _vm.model.empName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empName", $$v)
                              },
                              expression: "model.empName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "所屬法人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empCompany"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              disabled: "false",
                              placeholder: "请输入所屬法人"
                            },
                            model: {
                              value: _vm.model.empCompany,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empCompany", $$v)
                              },
                              expression: "model.empCompany"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "運單公司",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "logisticsCompany"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入運單公司" },
                            model: {
                              value: _vm.model.logisticsCompany,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "logisticsCompany", $$v)
                              },
                              expression: "model.logisticsCompany"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "運單單號",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "logisticsNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入運單單號" },
                            model: {
                              value: _vm.model.logisticsNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "logisticsNo", $$v)
                              },
                              expression: "model.logisticsNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }